export default __webpack_public_path__ + "static/media/gingelly.667437ea.JPG";